<script setup>
const route = useRoute()
const loading = ref(false)
const { Settings } = useSettings()

const { data: blob } = await useFetch(`/api/blob/${route.params.id}`, { key: 'aa' + route.params.id })
const { data: posts, refresh } = await useFetch(`/api/post/${route.params.id}`, { key: 'pp' + route.params.id })

useHead( {
  title: computed( () => `${Settings?.value.name} - ${blob?.value?.name ?? ''}`),
  link: [{ rel: 'alternate', type: 'application/rss+xml', title: Settings?.value?.name || 'Blob', href: `/feed/${route.params.id}` }]
})


const infiniteScrolling = async (isIntersecting) => {
  if (isIntersecting && posts.value?.length) {
    loading.value = true

    const sortBy = blob.value.sortBy
    const timestamp = new Date(posts.value[posts.value.length-1].date).getTime()

    const params = new URLSearchParams({ after: sortBy === 'date' ? timestamp : posts.value[posts.value.length-1][sortBy] })
    const ret = await $fetch(`/api/post/${route.params.id}?${params}`)
    if (ret?.length) {
      posts.value.push(...ret)
    }
    loading.value = false
  }
}

const selectedPost = ref({})
const editPostDialog = ref()
function editPost(post) {
  editPostDialog.value.open(post)
}

</script>

<template>
  <section class="blobs_blob">
    <Blobs />
    <div class="d-flex align-center flex-row justify-space-between flex-wrap">
      <p class='description'>{{blob?.description}}</p>
      <div class="blob_actions">
        <client-only>
          <v-menu open-on-hover location="left">
            <v-card width="400" rounded="0" class="blobInfo" :title="blob?.name" subtitle="List of sources and tags assigned to this blob">
              <v-list density='compact'>
                <v-list-item v-for='filter in blob?.Filter' :key='filter.id'>
                    <v-chip v-for='source in filter.sources' :key='source.id'  class='mr-1 mt-1'>{{source.name}}</v-chip>
                    <v-chip v-for='tag in filter.tags' :key='tag.id' :color='filter.inclusive ? "red": "primary"' class='mr-1 mt-1'>{{tag.name}}</v-chip>
                </v-list-item>
              </v-list>
            </v-card>
            <template v-slot:activator="{ props }"><v-btn v-bind="props" color='primary' variant='text' icon='mdi-information' target="_blank"/></template>
          </v-menu>
          <template v-slot:placeholder><v-btn icon='mdi-information' variant='text' color="primary"/></template>
        </client-only>        
        <!-- <v-tooltip text="Feed" location="top">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" target="_blank" :href="`/feed/${blob?.id}`" variant='text' color="primary" icon='mdi-rss' />
          </template>
        </v-tooltip> -->
        <v-tooltip text="Share" location="top">
          <template v-slot:activator="{ props }">        
            <v-btn v-bind="props" :to="`/share?blob_id=${route.params.id}`" variant='text' color="primary" icon='mdi-widgets-outline' />
          </template>
        </v-tooltip>
      </div>
    </div>

    <section class='container max-w-80 mt-6 postContainer'>
      <EditPost ref="editPostDialog" :post="selectedPost" @update="refresh"/>
      <Post v-for='post in posts'
        card
        :key='post.id'
        :post='post'
        @edit="editPost"
        @remove="posts.splice(id, 1)"
        @toggleVisibility="post.visible = !post.visible"
      />
      <div class='pa-1 ma-12 text-center' v-intersect="infiniteScrolling">
        <v-progress-circular v-if='loading'  indeterminate />
      </div>
    </section>
  </section>
</template>
<style>
.blobInfo .v-list-item:nth-child(odd) {
  background-color: #f3f3f3;
}
</style>